/**
 * Functions for wpsl single page
 */

'use strict';


var MCGMAP = (function ($) {

    var mapSearch, mapLocation;
    var searchMarkers = [];
    var infowindow;

    function initGmap() {
        var theCentres = $('.mc_centre_map');

        $.each(theCentres, function (indx, elm) {
            var mapId = $(elm).attr('id');
            initMap(mapId);
        });

        var centreSearch = $('#mc_centre_search');
        if (centreSearch.length > 0){
            initMapSearch('mc_centre_search');
        }
    }

    function initMap(mapId) {
        var mapContainer = jQuery('#' + mapId);

        var myLatLng = mapContainer.data();

        mapLocation = new google.maps.Map(document.getElementById(mapId), {
            zoom: 8,
            center: myLatLng,
            mapTypeId: 'roadmap',
            mapTypeControl: false,
            streetViewControl: false
        });

        var marker = new google.maps.Marker({
            position: myLatLng,
            map: mapLocation
        });
    }

    function initMapSearch(mapId){
        mapSearch = new google.maps.Map(document.getElementById(mapId), {
            zoom: 8,
            center: {lat: 53.453283, lng: -2.200342},
            mapTypeId: 'roadmap',
            mapTypeControl: false,
            streetViewControl: false
        });

        var seachtext = $('#wpsl-search-input').val();

        search(seachtext);
    }

    function search(searchText){
        $('#mc-centres-result-list ul li').remove();

        geocode(searchText, function (latLng) {
            $.post(myAjax.ajaxurl, {
                action: 'get_nearby_centre',
                lat: latLng['lat'],
                lng: latLng['lng']
            }, function (data) {
                if (data){
                    var length = data.length;

                    var storeLoca = [];

                    infowindow = new google.maps.InfoWindow({
                        content: 'xxx'
                    });


                    for (var i =0; i < length; i++){
                        var location = data[i];

                        var latLng = {
                            lat:  parseFloat(location.Lat),
                            lng: parseFloat(location.Lng)
                        };

                        var marker = new google.maps.Marker({
                            position: latLng,
                            map: mapSearch,
                            title: location.post_title
                        });

                        marker.addListener('click', function() {
                            infowindow.setContent(this.getTitle());
                            infowindow.open(mapSearch, this);
                        });


                        searchMarkers[location.post_id] = marker;

                        var loca = $('<li>'+ location.location +'</li>');
                        storeLoca.push(loca)

                        if (i == 0){
                            mapSearch.setCenter(latLng);
                        }
                    }

                    $('#mc-centres-result-list ul').append(storeLoca);

                    $('.wpsl-locations-details').on('click', function () {
                        var that = $(this);
                        var markerId = that.data('id');
                        var marker = searchMarkers[markerId];

                        var latLng = marker.getPosition(); // returns LatLng object
                        mapSearch.setCenter(latLng); // setCenter takes a LatLng object

                        infowindow.setContent(marker.getTitle());

                        infowindow.open(mapSearch, marker);
                    });
                }
            });
        });
    }

    function geocode(text, callbackFunc){
        var geocoder = new google.maps.Geocoder();
        var latLng;

        var request = {
            'address': text,
            'componentRestrictions': {
                'country': 'GB'
            }
        };

        geocoder.geocode(request, function (response, status) {
            if (status == google.maps.GeocoderStatus.OK) {

                latLng = {
                    lat: response[0].geometry.location.lat(),
                    lng: response[0].geometry.location.lng()
                }

                callbackFunc(latLng);
            }
        });
    }

    function xxx(){

    }

    return {
        initGoogleMap: initGmap
    }

})(jQuery);
